import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { FieldValueInterface } from '@vendasta/crm';
import { BlankValueComponent, CustomCellComponent } from '@vendasta/galaxy/table';

@Component({
  selector: 'crm-date-cell',
  templateUrl: `date-cell.component.html`,
  imports: [CommonModule, BlankValueComponent, DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateCellComponent extends CustomCellComponent {
  fieldValues = signal<(FieldValueInterface | null)[]>([]);
  set value(newValues: (FieldValueInterface | null)[]) {
    this.fieldValues.set(newValues);
  }

  dateValue = computed(() => {
    const fieldValues = this.fieldValues();
    const dateField = fieldValues.find(
      (fieldValue) => fieldValue?.dateValue
    );

    if (!dateField?.dateValue) {
      return null;
    }

    return dateField.dateValue;
  });
}

